// cr.js «Моё видео» принимает placement только целым числом: на строке он пишет
// «критические ошибки в конфиге» и не запускает плеер. Из бандла id приходит числом,
// а из БД (block_id — CharField) строкой, поэтому приводим здесь.
export function toPlacementId(value) {
    const id = Number(value);

    return Number.isInteger(id) && id > 0 ? id : null;
}
